import { render, staticRenderFns } from "./AIDocToQuizSecurityTooltip.vue?vue&type=template&id=5462e2c0&scoped=true&"
import script from "./AIDocToQuizSecurityTooltip.vue?vue&type=script&lang=js&"
export * from "./AIDocToQuizSecurityTooltip.vue?vue&type=script&lang=js&"
import style0 from "./AIDocToQuizSecurityTooltip.vue?vue&type=style&index=0&id=5462e2c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462e2c0",
  null
  
)

export default component.exports